// src/components/ProtectedRoute.jsx
import React from 'react';
import { useUser } from '../context/UserContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { usuario, rol, cargando } = useUser();

  if (cargando) {
    return <div style={{ padding: '20px', color: 'white' }}>Cargando...</div>;
  }

  if (!usuario) {
    return <div style={{ padding: '20px', color: 'white' }}>Por favor inicia sesión.</div>;
  }

  if (!allowedRoles.includes(rol)) {
    return (
      <div style={{ padding: '20px', color: 'white' }}>
        No tienes permiso para acceder a esta sección.
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
